'use strict';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames/bind';

import { roles, RBAC } from '@/roles';

import { appSelectors } from '@/state/domains/app';
import { usersSelectors } from '@/state/domains/users';

import ActionBar from './ActionBar';
import List from './List';

import s from './styles.scss';

const sx = cn.bind(s);

const accessCtl = new RBAC(roles);

export default connect(
	(state, props) => ({
		responsive: appSelectors.getResponsive(state, props),
		canEdit: usersSelectors.userCan(state, { ...props, action: 'userRoute:edit' }),
	}),
	{
	}
)(
	({ responsive, canEdit }) => {

		const [ expanded, setExpanded ] = useState(false);

		return (
			<div className={ sx('aside', { mobile: !responsive.md }) }>
				<div className={ s.actionBar }>
					{
						canEdit &&
						<ActionBar
							expanded={ expanded }
							setExpanded={ setExpanded }
						/>
					}
				</div>
				<div className={ s.listCont }>
					<List canEdit={ canEdit } expanded={ expanded }/>
				</div>
			</div>
		);
	}
);
